export default {
  setActiveStep(state, activeStep) {
    state.activeStep = activeStep;
  },
  toggleLoading(state, isLoading = false) {
    state.loading = isLoading;
  },
  setAppConfigV2(state, patch) {
    const newAppConfig = {
      ...state.appConfigV2,
      ...patch,
    };

    state.appConfigV2 = newAppConfig;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/store/mutations.js